import { Controller } from "@hotwired/stimulus";

// Toggles the checkout order-summary fee breakdown. One instance is scoped to the
// desktop overview panel and another to the mobile bar; each toggles its own panel
// and rotates its own chevron. The panel re-renders collapsed on every step (Turbo
// swaps the whole overview), which matches the "collapsed by default" requirement.
// While the fee is pending (no payment option picked yet) the server renders the
// breakdown disabled; setCheckoutFeeBreakdownEnabled() arms it once a fee is known.
export default class extends Controller {
  static targets = ["panel", "chevron", "trigger"];
  static values = { enabled: { type: Boolean, default: true } };

  enabledValueChanged(enabled) {
    if (this.hasChevronTarget) {
      this.chevronTarget.classList.toggle("hidden", !enabled);
    }
    if (this.hasTriggerTarget) {
      this.triggerTarget.classList.toggle("cursor-pointer", enabled && this.hasPanelTarget);
    }
    if (!enabled) this.collapse();
  }

  toggle() {
    if (!this.enabledValue || !this.hasPanelTarget) return;

    const expanded = !this.panelTarget.classList.toggle("hidden");

    if (this.hasChevronTarget) {
      this.chevronTarget.classList.toggle("rotate-180", expanded);
    }
  }

  collapse() {
    if (this.hasPanelTarget) this.panelTarget.classList.add("hidden");
    if (this.hasChevronTarget) this.chevronTarget.classList.remove("rotate-180");
  }
}
